<template>
    <div v-if="showAppDown">
        <div class="panel" align="center">
            <h4 class="redColoredText">
                Anwendung nicht verfügbar
            </h4>
            <p>
                Die Anwendung steht aktuell leider nicht zur Verfügung. Bitte versuchen Sie es später erneut.
            </p>
        </div>
    </div>
  <div v-else-if="isInitializationDone" class="panel" id="unemployed-app">
    <span id="app-top"></span>
    <form @submit.prevent="handleSubmit" v-if="!submitted">

      <h5>Fragen zum Arbeitsvertrag:</h5>

      <label>
        <a name="end-date"/>
        <p class="question">Der Arbeitsvertrag endet zum...</p>
        <date-picker placeholder="Bitte Datum auswählen" type="date" value-type="format" :editable="false"
                     format="DD.MM.YYYY" v-model="rawDates.endDate" required/>
        <p v-if="validation.showEndDateNotSelected" class="validation-error">Bitte füllen Sie das Feld aus</p>
      </label>


      

      <!-- Show always -->
      <h5>Ihre Daten:</h5>
      <label class="row collapse">
        <div class="columns small-1">
          <input type="radio" name="gender" value="Herr" v-model="fields.gender" required>
        </div>
        <div class="columns small-11">Herr</div>
      </label>
      <label class="row collapse">
        <div class="columns small-1">
          <input type="radio" name="gender" value="Frau" v-model="fields.gender">
        </div>
        <div class="columns small-11">Frau</div>
      </label>

      <label class="question">
        Ihr Vorname:
        <input type="text" name="firstname" v-model="fields.firstname" required>
        <p v-if="validation.showPrenameError" class="validation-error">Bitte entfernen Sie Zahlen und Sonderzeichen</p>
      </label>

      <label class="question">
        Ihr Nachname:
        <input type="text" name="surname" v-model="fields.surname" required>
        <p v-if="validation.showSurnameError" class="validation-error">Bitte entfernen Sie Zahlen und Sonderzeichen</p>
      </label>

      <label class="question">
        Straße
        <input type="text" name="street" v-model="fields.street" required>
        <p v-if="validation.showStreetError" class="validation-error">Bitte entfernen Sie Zahlen und Sonderzeichen</p>
      </label>

      <label class="question">
        Hausnummer:
        <input type="text" name="housenumber" class="short" v-model="fields.housenumber" required>
        <p v-if="validation.showHousenumberError" class="validation-error">Bitte entfernen Sie etwaige Sonderzeichen</p>
      </label>

      <label class="question">
        PLZ:
        <input type="text" name="zip" class="short" pattern="[0-9]{5}" title="Gültige PLZ (fünf Zahlen)" v-model="fields.zip" required>
        <p v-if="validation.showZipError" class="validation-error">Bitte geben Sie eine fünfstellige PLZ ein</p>
      </label>

      <label class="question">
        Ort:
        <input type="text" name="city" v-model="fields.city" required>
        <p v-if="validation.showCityError" class="validation-error">Bitte entfernen Sie Zahlen oder Sonderzeichen</p>
      </label>

      <label class="question">
        Ihre E-Mail-Adresse:
        <input type="email" name="email" v-model="fields.email" required>
      </label>

      <label class="question">
        Ihre Telefon-Nummer (für Rückfragen):
        <input type="text" name="phone" v-model="fields.phone" required>
      </label>

      <label class="row collapse">
        <div class="columns small-1">
          <input type="checkbox" name="dataprivacy" v-model="fields.dataprivacy" required>
        </div>
        <div class="columns small-11">Ich akzeptiere die <a href="https://ratis.de/datenschutz/" target="_blank">Datenschutzerklärung</a></div>
      </label>
      <label class="row collapse">
        <div class="columns small-1">
          <input type="checkbox" name="dataprivacy" v-model="fields.aadataprivacy" required>
        </div>
        <div class="columns small-11">Ich akzeptiere die <a href="https://www.arbeitsagentur.de/datenschutzerklaerung" target="_blank">Datenschutzerklärung der Bundesagentur für Arbeit</a></div>
      </label>

      <button class="button" type="submit" :disabled="submitting" style="margin-top: 15px">
        <span v-if="submitting">
          Wird gesendet...
          <img src="./assets/loader.svg">
        </span>
        <span v-else>Kostenlos arbeitslos melden</span>
      </button>
    </form>

    <div id="page2" v-if="submitted && !error">
      <ConfirmationPage :message=message :show_calltoaction=show_calltoaction :uid=uid />
    </div>

    <div id="error" v-if="error">
      <div class="alert-box alert">
        <h3>Fehler</h3>
        <p>
          Leider ist ein Fehler aufgetreten und Ihre Arbeitslosen-Meldung konnte nicht erfolgen.
          Bitte versuchen Sie es erneut.
          Bei anhaltenden Problemen kontaktieren Sie uns unter <a href="mailto:info@ratis.de">info@ratis.de</a>.
        </p>
        <p>
          Sollten Sie trotz mehrerer Versuche anhaltende Probleme mit unserem Formular haben, empfehlen wir Ihnen
          außerdem sich selbst unter dem verlinkten <a
          href="https://con.arbeitsagentur.de/prod/apok/kontakt/de/terminvereinbarung/arbeitsvermittlung">Formular</a>
          bei der Agentur für Arbeit arbeitssuchend zu melden.
        </p>
        <p>
          Weitere Informationen, Hilfe und alles zum Thema Abfindung nach einer Kündigung finden Sie <a
          href="https://ratis.de/kuendigung/">hier</a>.
        </p>
        <p><strong>Fehlermeldung: {{ error_msg }}</strong></p>
      </div>
    </div>
  </div>
</template>


<script>
import ConfirmationPage from "./ConfirmationPage.vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/de';
import moment from "moment";
import Config from './constants/Config';
import Maintenance from './api/maintenance';
import Unemployed from './api/unemployed';

export default {
    data() {
        return {
            fields: {
                firstname: null,
                surname: null,
                street: null,
                housenumber: null,
                zip: null,
                city: null
            },
            trackingUrl: Config.TRACKING_URL,
            infoboxes: {
                type: false,
            },
            submitted: false, // true when submitted
            submitting: false, // true while submitting,
            error: false, // true if error occured
            error_msg: '',
            message: '',
            show_calltoaction: false,
            uid: '',
            rawDates: {
                endDate: null,
            },
            validation: {
                showEndDateNotSelected: false,
                showPrenameError: false,
                showSurnameError: false,
                showCityError: false,
                showStreetError: false,
                showHousenumberError: false,
                showZipError: false,
                nameRegex: /^[a-zA-ZüöäÜÖÄáàâÁÀÂéèêÉÈÊß\-]+(\s[a-zA-ZüöäÜÖÄáàâÁÀÂéèêÉÈÊß\-]+)*$/,
                streetRegex: /^[a-zA-ZüöäÜÖÄáàâÁÀÂéèêÉÈÊß\-\.\/]+(\s[a-zA-ZüöäÜÖÄáàâÁÀÂéèêÉÈÊß\-\.\/]+)*$/,
                houseNumberRegex: /^[1-9]+(\s?[a-zA-ZüöäÜÖÄáàâÁÀÂéèêÉÈÊß\-\.\/0-9]+)*$/,
                zipRegex: /^[1-9]{1}[0-9]{4}$/,
                cityRegex: /^[a-zA-ZüöäÜÖÄáàâÁÀÂéèêÉÈÊß\-\.\/]+(\s[a-zA-ZüöäÜÖÄáàâÁÀÂéèêÉÈÊß\-\.\/]+)*$/
            },
            showAppDown: false,
            isInitializationDone: false
        };
    },
    components: {
        ConfirmationPage,
        DatePicker
    },
    computed: {
        areDatesSetCorrect()
        {
            return !(this.validation.showNewJobDateNotSelected
                || this.validation.showReceivedDateNotSelected
                || this.validation.showEndDateNotSelected
                || this.validation.showBeginDateNotSelected);
        },
        areAfARelevantFieldsCorrect()
        {
            return !(this.validation.showCityError
                || this.validation.showZipError
                || this.validation.showHousenumberError
                || this.validation.showStreetError
                || this.validation.showSurnameError
                || this.validation.showPrenameError);
        }
    },

    methods: {
        handleSubmit() {
            this.validateFormInput();

            if(this.areDatesSetCorrect && this.areAfARelevantFieldsCorrect)
            {
                this.shrinkFieldsObject();
                this.sendData();
            }
        },
        async sendData() {
            this.submitting = true;

            try
            {
                let response = await Unemployed.register(this.fields);

                if (response.error)
                {
                    this.error = true;
                    this.error_msg = response.error_msg;
                    this.submitted = true;
                }
                else
                {
                    this.submitted = true;
                    this.message = response.message;
                    this.show_calltoaction = response.show_calltoaction;
                    this.uid = response.uid;
                    this.redirectToTracking()
                }
            }
            catch (error)
            {
                console.log(error);
                this.error = true;
                this.error_msg = error;
                this.submitted = true;
            }

            // Scroll to top of the app
            var top = document.getElementById("app-top");
            top.scrollIntoView({behavior: "smooth"});

            //this.createTrackingIframe();
           
        },
        //deprecated
        createTrackingIframe()
        {
          let iframe = document.createElement('iframe');
          iframe.setAttribute('id', 'trackingIframe');
          iframe.setAttribute('src', this.trackingUrl);
          iframe.style.display = "none";
          document.body.appendChild(iframe);
          let me = this;
          iframe.onload = () => me.removeTrackingIframe();
        },
        redirectToTracking()
        {
            setTimeout(() => {
                window.location.href = this.trackingUrl;
            }, 1000);
        },
        removeTrackingIframe()
        {
          let iframe = document.getElementById('trackingIframe');
          document.body.removeChild(iframe);
        },
        validateDateInput()
        {
            
            this.validation.showEndDateNotSelected    = (this.rawDates.endDate    === null);

            this.scrollFirstErrorIntoView();
        },
        resetDateValidation()
        {
            this.validation.showEndDateNotSelected      = false;
        },
        scrollFirstErrorIntoView()
        {
            if(this.validation.showBeginDateNotSelected)
                location.hash = '#begin-date';
            else if(this.validation.showEndDateNotSelected)
                location.hash = '#end-date';
            else if(this.validation.showReceivedDateNotSelected)
                location.hash = '#received-date';
            else if(this.validation.showNewJobDateNotSelected)
                location.hash = '#new-job-date';
        },
        validateFormInput()
        {
            this.resetDateValidation();
            this.resetAfARelevantValidation();
            this.validateDateInput();
            this.validateAfARelevantFields();
        },
        validateAfARelevantFields()
        {
            this.validation.showCityError         = !this.fields.city.match(this.validation.cityRegex);
            this.validation.showHousenumberError  = !this.fields.housenumber.match(this.validation.houseNumberRegex);
            this.validation.showPrenameError      = !this.fields.firstname.match(this.validation.nameRegex);
            this.validation.showSurnameError      = !this.fields.surname.match(this.validation.nameRegex);
            this.validation.showZipError          = !this.fields.zip.match(this.validation.zipRegex);
            this.validation.showStreetError       = !this.fields.street.match(this.validation.streetRegex);
        },
        resetAfARelevantValidation()
        {
            this.validation.showCityError         = false;
            this.validation.showHousenumberError  = false;
            this.validation.showPrenameError      = false;
            this.validation.showSurnameError      = false;
            this.validation.showZipError          = false;
            this.validation.showStreetError       = false;
        },
        shrinkFieldsObject()
        {
            //TODO: Code review - this is an unexpected behaviour, please change the whole code and make it unneccessary

            let unnamedFields = [
                'end_date',
            ];
            let me = this;

            // Remove all elements that are hidden (offsetHeight == 0) from fields object
            // so they are not submitted to API
            Object.keys(me.fields).forEach(function(key) {

                if(!unnamedFields.includes(key))
                {
                    var x = document.getElementsByName(key);

                    if (x.length === 0 || x[0].offsetHeight == 0) {
                        delete me.fields[key];
                    }
                }
            });
        },
        async checkHealth()
        {
            try
            {
                let response = await Maintenance.checkHealth();

                if (response.is_down)
                    this.showAppDown = true;
            }
            catch (error)
            {
                this.showAppDown = true;
            }
        }
    },
    async mounted()
    {
        await this.checkHealth();
        this.isInitializationDone = true;
    },
    watch: {
        'rawDates.endDate': function(newValue){
            if(newValue !== null)
            {
                let splittedDate = newValue.split('.');

                this.fields.end_date = splittedDate[2] + '-' + splittedDate[1] + '-' + splittedDate[0];
            }
            else
                delete this.fields.end_date;
        },
    }
};
</script>


<style>
#unemployed-app h5 {
    font-weight: bold;
    font-size: 1.3rem;
    color: #4d4d4d;
    margin: 1.5rem 0 1rem 0;
}

#unemployed-app .question {
    margin: 1.25rem 0 0.5rem 0;
    font-weight: bold;
    color: #4d4d4d;
    font-size: 1rem;
}

#unemployed-app input[type=date] {
    width: 100%;
    max-width: 200px;
    box-sizing: border-box;
}

#unemployed-app input.short {
    width: 100%;
    max-width: 200px;
    box-sizing: border-box;
}

#unemployed-app button[type=submit] {
    font-weight: bold;
}

/* Consistent space between radio options */
#unemployed-app .small-11 {
    margin-bottom: 15px;
}

.mx-datepicker-popup .mx-btn {
    background-color: transparent !important;
}
.validation-error {
    color: red !important;
}

.redColoredText{
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/App.vue